export const GET_USER_BY_ID =
  'pages/coach/userManagement/singleUser/getUserById'
